import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchTaco4FoodById } from '../../../redux/actions/nutridataActions';
import Tips from '../../../components/Tips/Tips';

import '../styles/ShowTacoFood.css';
import '../../../Mobile.css';

import GraphicFood from '../../../components/GraphicFood/GraphicFood';
import DynamicFoodDetails from './DynamicFoodDetails';
import foodLogoCategory from '../../../assets/img/shortcut_icon/allFoods.png';
import Accordion from '../../../components/Accordion/Accordion';
import { setCurrentTaco4Food } from '../../../redux/slices/nutridataSlice';
import LoadingEllipsis from '../../../components/LoadingEllipsis/LoadingEllipsis';

const ShowTaco4Foods = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { food_id } = useParams();

  const { currentTaco4Food, loading, error } = useSelector(state => state.nutridata);

  // console.log(currentTaco4Food);
  const dica = (<Tips id="tips-FoodsProps" message="Os valores aparecem na ordem da maior para menor quantidade presente no alimento." />);


  useEffect(() => {
    if (food_id) {
      dispatch(fetchTaco4FoodById(food_id));
    }
  }, [dispatch, food_id]);

  if (loading) {
    return <LoadingEllipsis message={'Carregando Alimento'} />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!currentTaco4Food) {
    return <div>No data found for the specified food.</div>;
  }

  const handleBack = () => {
    navigate('/home/nutridata/get/taco4foods');
    dispatch(setCurrentTaco4Food(null));
  };

  const dataForChart = [
    { id: 'Proteínas', label: 'Proteínas', value: currentTaco4Food.protein || 0 },
    { id: 'Gorduras', label: 'Gorduras', value: currentTaco4Food.total_saturated || 0 },
    { id: 'Carboidratos', label: 'Carboidratos', value: currentTaco4Food.carbohydrates || 0 },
    { id: 'Lipídeos', label: 'Lipídeos', value: currentTaco4Food.lipids || 0 },
  ];

  const calculatePercentual = (value) => {
    const total = currentTaco4Food.protein + currentTaco4Food.lipids + currentTaco4Food.cholesterol + currentTaco4Food.carbohydrates || 1;
    return ((value / total) * 100).toFixed(2);
  };


  return (
    <>
      <div className="tacoFoodCard">
        <div className="tacoFoodColumn1">
          <div className="row1">
            <div className="taco-colA">
              <img src={foodLogoCategory} alt="imagem do alimento" />
            </div>
            <div className="taco-colB">
              <label className='lbl-fruit-name'>{currentTaco4Food.food_name}</label>
              <label className='lbl-category-food'>{currentTaco4Food.category_name}</label>
            </div>
          </div>
          <div className="row2">
            <div className='tag-total'>Total</div>
            <div className='tag-kcal'>{currentTaco4Food.kcal}</div>
            <div className='tag-calories'>Kcal</div>
          </div>
          <div className="row3">
            <div className='r3-describe'>Quantidade de calorias em cada 100g</div>
          </div>
        </div>

        <div className="tacoFoodColumn2">
          <GraphicFood data={dataForChart} />
        </div>

        <div className="tacoFoodColumn3">

          <div className="row boxLine">
            <div className="boxLabel">Proteínas</div>
            {/* <div className="boxPercentual">
              {calculatePercentual(currentTaco4Food.protein)}%
            </div> */}
            <div className="boxValue proteins">
              {currentTaco4Food.protein ?? "N/A"} {currentTaco4Food.protein_unit}
            </div>
          </div>
          <div className="row boxLine">
            <div className="boxLabel">Lipídeos</div>
            {/* <div className="boxPercentual">
              {calculatePercentual(currentTaco4Food.lipids)}%
            </div> */}
            <div className="boxValue lipids">
              {currentTaco4Food.lipids ?? "N/A"} {currentTaco4Food.lipids_unit}
            </div>
          </div>
          <div className="row boxLine">
            <div className="boxLabel">Saturados</div>
            {/* <div className="boxPercentual">
              {calculatePercentual(currentTaco4Food.saturated)}%
            </div> */}
            <div className="boxValue saturated">
              {currentTaco4Food.saturated ?? "N/A"} {currentTaco4Food.saturated_unit}
            </div>
          </div>
          <div className="row boxLine">
            <div className="boxLabel">Carboidratos</div>
            {/* <div className="boxPercentual">
              {calculatePercentual(currentTaco4Food.carbohydrates)}%
            </div> */}
            <div className="boxValue carbohydrates">
              {currentTaco4Food.carbohydrates ?? "N/A"} {currentTaco4Food.carbohydrates_unit}
            </div>
          </div>
        </div>
      </div>

      <Accordion className="accordion" title={<div className='accordionTitleLine'>{currentTaco4Food.food_name} - Informações Completas {dica}</div>}>
        <span />
        <DynamicFoodDetails food={currentTaco4Food} />
      </Accordion>

      <div className="tacoFoodActions">
        <button type="button" className='backBtn' onClick={handleBack}>Voltar</button>
      </div>
    </>
  );
};

export default ShowTaco4Foods;